module.exports = __webpack_public_path__ + "static/img/Workflows.f73794d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Workflows.png
// module id = Vv4M
// module chunks = 0